import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';

export interface StateLookupResponse {
  stateCode: string;
  city: string;
  municipalityCode: string;
  error: string;
  success: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UsAddressLookupService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  public lookupStateFromZipCode(zipCode: string): Observable<StateLookupResponse> {
    return this.httpClient.get<StateLookupResponse>(this.configService.getApiPath(`addresslookup/stateAndMunicipality/${zipCode}`));
  }
}
